import React from 'react'
import { array, string } from 'prop-types'

import RankedListItem from './component/RankedListItem'

import List from '@/component/Primitive/List'
import SmartLink from '@/component/Primitive/SmartLink'
import Type from '@/component/Primitive/Type'

import styles from './RankedList.module.scss'

const RankedList = ({ listData, titlePrimary, titleSecondary }) => {
  return (
    <div className={styles.RankedList}>
      {titlePrimary && (
        <div className={styles.RankedListTitle}>
          <Type size="heading8" weight="bold">
            {titlePrimary}
            {titleSecondary && (
              <span className={styles.RankedListTitleSecondary}>
                {titleSecondary}
              </span>
            )}
          </Type>
        </div>
      )}
      <List unstyled>
        {listData.map((item, i) => {
          return (
            <li key={`RankedList-item-${i}`}>
              {item.href && (
                <SmartLink href={item.href} className={styles.RankedListLink}>
                  <RankedListItem
                    i={i}
                    content={item.content}
                    category={item.category || null}
                  />
                </SmartLink>
              )}
            </li>
          )
        })}
      </List>
    </div>
  )
}

RankedList.propTypes = {
  listData: array.isRequired,
  titlePrimary: string,
  titleSecondary: string
}

export default RankedList
